module.exports = __webpack_public_path__ + "static/app-store-ac53f75d60bcb8701a31b1d56c3f4a34.svg";